export const META_PIXEL_ID = "1712116310080716";

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};

interface MetaPixelWindow extends Window {
  fbq?: FbqFunction;
  _fbq?: FbqFunction;
}

function getMetaWindow(): MetaPixelWindow | null {
  return typeof window === "undefined" ? null : (window as MetaPixelWindow);
}

export function initializeMetaPixel() {
  const metaWindow = getMetaWindow();
  if (!metaWindow || metaWindow.fbq?.loaded) return;

  const existingScript = document.querySelector(
    `script[data-meta-pixel="${META_PIXEL_ID}"]`,
  );
  if (existingScript) return;

  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue?.push(args);
    }
  }) as FbqFunction;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";

  metaWindow.fbq = fbq;
  metaWindow._fbq = fbq;
  fbq("init", META_PIXEL_ID);
  fbq("track", "PageView");
  fbq("track", "ViewContent", {
    content_name: "Pequeños Pasos, Grandes Logros",
    content_category: "Colección digital educativa",
    content_type: "product",
    currency: "USD",
    value: 17,
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  script.dataset.metaPixel = META_PIXEL_ID;
  document.head.appendChild(script);
}

export function trackMetaEvent(event: string, parameters?: Record<string, unknown>) {
  const metaWindow = getMetaWindow();
  if (!metaWindow?.fbq) return;
  metaWindow.fbq("track", event, parameters);
}
